import { Pipe, PipeTransform } from '@angular/core';

import { formatMediumDateTime, formatShortTime, formatMediumDate } from './DateFormatters';

@Pipe({ name: 'vbDateTimeMedium',
	standalone: false
})
export class VbDateTimeMediumPipe implements PipeTransform {
	public transform = formatMediumDateTime;
}

@Pipe({ name: 'vbDateMedium',
	standalone: false
})
export class VbDateMediumPipe implements PipeTransform {
	public transform = formatMediumDate;
}

@Pipe({ name: 'vbTimeShort',
	standalone: false
})
export class VbTimeShortPipe implements PipeTransform {
	public transform = formatShortTime;
}
